// extracted by mini-css-extract-plugin
export default {"link":"UJ-z","disabled":"VJ-z"};